import { WinnerRole } from '../../models/shared/winner-role-types';

export const getRoleRank = (role?: WinnerRole | string): number => {
  if (role === 'Winner') return 0;
  if (role === 'Finalist') return 1;
  return 2;
};
